import { getMeta } from './helpers';

// Set webpack public asset url
window.__webpack_public_path__ = getMeta('theme-url');

import { Application } from '@hotwired/stimulus';
import StickyHeaderController from './controllers/sticky-header-controller';
import MobileNavToggleController from './controllers/mobile-nav-toggle-controller';
import MobileNavController from './controllers/mobile-nav-controller';
import AccessibleNavController from './controllers/accessible-nav-controller';
import AxiosFormController from './controllers/axios-form-controller';
import BlockAsyncController from './controllers/block-async-controller';
import ExpandableController from './controllers/expandable-controller';
import ModalController from './controllers/modal-controller';
import SliderController from './controllers/slider-controller';
import TabController from './controllers/tab-controller';
import TabsController from './controllers/tabs-controller';
import ReadMoreController from './controllers/read-more-controller';
import SelectController from "./controllers/select-controller";
import CalendarController from "./controllers/calendar-controller";
import CalendarStripController from "./controllers/calendar-strip-controller";
import CalendarEventsController from "./controllers/calendar-events-controller";
import VideoController from "./controllers/video-controller";
import PostController from "./controllers/post-controller";
import PopupController from './controllers/popup-controller';
import BackButtonController from './controllers/back-button-controller';

// require('./navigation');
require('./lightbox');
require('./misc');

const application = Application.start();

application.register('sticky-header', StickyHeaderController);
application.register('mobile-nav-toggle', MobileNavToggleController);
application.register('mobile-nav', MobileNavController);
application.register('accessible-nav', AccessibleNavController);
application.register('block-async', BlockAsyncController);
application.register('axios-form', AxiosFormController);
application.register('modal', ModalController);
application.register('tab', TabController);
application.register('tabs', TabsController);
application.register('read-more', ReadMoreController);
application.register('slider', SliderController);
application.register('expandable', ExpandableController);
application.register('select', SelectController);
application.register('calendar', CalendarController);
application.register('calendar-strip', CalendarStripController);
application.register('calendar-events', CalendarEventsController);
application.register('video', VideoController);
application.register('post', PostController);
application.register('popup', PopupController);
application.register('back-button', BackButtonController);
